// The pxToEm() function helps you to convert a px unit into a em unit. Since they are based off font size, you need to pass the font size in px as a second argument.

export const pxToEm = (px: number, fontSizePx: number): string => {
    return `${px / fontSizePx}em`;
};
